// Mixins
import { GoogleAnalyticsMixins } from '@/app/mixins/utils/google-analytics-mixins';
import { comingSoonMixins } from '@/app/mixins/utils/coming-soon-mixins';

export default {
    name: 'LandingPageHeroWhyUsCard',
    mixins: [
        GoogleAnalyticsMixins,
        comingSoonMixins
    ],
    props: {
			imageUrl: {
				type: String
			},
			description: {
				type: String,
				required: true
			},
			circleTitle: {
				type: String
			},
			circleDescription: {
				type: String
			},
			frameColor: {
				type: String
			},
			stepNumber: {
				type: Number
			},
			hasLatitudePayLogo: {
				type: Boolean,
				default: false
			}
	}, data(){
		return {
			isLeftAligned: this.stepNumber == 1 || this.stepNumber == 2
		}
	}
}